<template>
  <div class="main-box">
    <div class="area-tree" style="height: 600px; padding: 2px 30px;">
      <div class="tree-box" style="overflow: auto;">
        <div class="zTreeDemoBackground left">
          <ul id="treeDemo" class="ztree"></ul>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer" style="text-align: center; height: 40px; line-height: 40px;">
      <xr-button type="primary" @click="getSelectedValue">确定</xr-button>
      <xr-button type="default" @click="handleCloseDialog">取消</xr-button>
    </div>
  </div>
</template>

<script>
  import '../../../../../static/js/jquery-3.7.1'
  import "../../../../../plugins/zTree/js/jquery.ztree.core.min.js";
  import "../../../../../plugins/zTree/js/jquery.ztree.excheck.min.js";

  export default {
    name: "pageSelectOrg",
    data (){
      return {
        roleId: '',
        setting:{
          check:{
            enable: true,
            chkStyle: "checkbox",
            chkboxType: { "Y": "ps", "N": "ps" }
          },
          data:{
            simpleData:{
              enable: true,
              idKey: "id",
              pIdKey: "p_id",
              rootPId: '-1'
            }
          },
          view: {
            expandAll: true,  // 设置为 true 即可默认展开所有节点
            showIcon: false
          },
          edit: {
            drag: {
              // 打开复制功能，Ctrl+鼠标左键点击后拖拽
              isCopy: true,
              // 打开移动功能，鼠标左键点击后拖拽
              isMove: true
            },
            // 打开编辑
            enable: true,
            // 关闭删除
            showRemoveBtn: false,
            // 关闭修改名称
            showRenameBtn: false
          }
        },
        zNodes: [],
        treeObj: new Object(),
        ids:''
      }
    },
    components: {

    },
    methods: {
      init(roleId) {
        this.roleId = roleId;
        this.initMenuTree(roleId);
      },
      //初始化菜单树
      initMenuTree: function(id){
        return this.request({
          method:'post',
          url:'/web/service',
          params:{
            'method':'tCoreMenu_listRoleTree',
            'roleId': id
          }
        }).then((response) =>{          //这里使用了ES6的语法   //请求成功返回的数据
          console.log(response)
          if (response.code === 0) {
            this.zNodes = response.rows;
            this.treeObj = $.fn.zTree.init($("#treeDemo"), this.setting, this.zNodes);
            this.treeObj.expandAll(true);
            let nodes = this.treeObj.getNodes();
            if (this.ids){
              // this.getCatalogList();
            }
          }
        })
      },
      //关闭窗口
      handleCloseDialog(){
        this.dialogVisible = false;
        this.$emit('cancelMethod');
      },
      //获取选中的值
      getSelectedValue(){
        // 获取当前勾选的节点数组
        let selectedNodes = this.treeObj.getCheckedNodes(true);
        let ids = '';
        // 遍历数组，打印每个节点的名称
        for (let i = 0; i < selectedNodes.length; i++) {
          console.log(selectedNodes[i].id);
          if(ids === ''){
            ids += selectedNodes[i].id;
          }else{
            ids += ',' + selectedNodes[i].id;
          }
        }

        //批量保存  tCoreRoleMenu_batchSave
        let temp = new Object();
        temp['roleId'] = this.roleId;
        temp['ids'] = ids;
        temp['permissionTypeId'] = 'T_CORE_MENU';
        return this.request({
          method: 'post',
          url: '/web/service?method=tCoreRoleMenu_batchSave',
          params: temp
        }).then((response) =>{          //这里使用了ES6的语法   //请求成功返回的数据
          // 请求成功返回的数据
          //如果返回编码不为0，提示失败语
          if (response.code != '0') {
            this.$message.error(response.msg);
            return false;
          }
          this.$message({message: '操作成功', type: 'success', duration: 1500, onClose: () => {
              this.dialogVisible = false

            }
          })

        })


        let list = this.$refs.xrTreeTable.multipleSelection;
        let value = '';
        if(list == null || list.length < 1){
          alert('请选择！');
          return false;
        }

        list.forEach(item => {
          if(!!item){
            if(value == ''){
              value = item;
            }else{
              value += ',' + item;
            }
          }
        })
        this.$emit('confirmMethod',value,'');
      }
    }
  }
</script>
<style>
  @import '../../../../../plugins/zTree/css/zTreeStyle/zTreeStyle.css';
</style>




// WEBPACK FOOTER //
// src/components/PageSelect/core/menu/menuMultiplePageSelect.vue